import { createReducer } from 'helpers/reducers-helper';
import { useReducer } from 'react';
import createUseContext from 'constate';
import merge from 'lodash/merge';
import { repo } from 'index';

const RESPONSE_USER_INFO = 'RESPONSE_USER_INFO';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE';
export const HAS_LICENSE_PLATES = 'HAS_LICENSE_PLATES';
export const HAS_PAYMENTS = 'HAS_PAYMENTS';

export const PAGE_PROFILE = 'profile';
export const PAGE_DRIVERS = 'drivers';
export const PAGE_LICENSE_PLATES = 'license-plates';
export const PAGE_PAYMENT = 'payment';
export const PAGE_ORDERS = 'orders';
export const PAGE_STATS = 'stats';
export const PAGE_COUPON = 'coupon';
export const PAGE_POINTS = 'points';

const useApp = () => {
  const initState = {
    currentPage: PAGE_PROFILE,
    me: null,
    hasLicensePlates: true,
    hasPayments: true,
  };

  const responseUserInfo = (state, payload) => merge({}, state, { me: payload });
  const updateUserInfo = (state, payload) => ({ ...state, me: payload });
  const hasLicensePlates = (state, payload) => ({ ...state, hasLicensePlates: payload });
  const hasPayments = (state, payload) => ({ ...state, hasPayments: payload });
  const changeCurrentPage = (state, payload) => merge({}, state, { currentPage: payload });

  const reducer = createReducer(
    {
      [RESPONSE_USER_INFO]: responseUserInfo,
      [UPDATE_USER_INFO]: updateUserInfo,
      [CHANGE_CURRENT_PAGE]: changeCurrentPage,
      [HAS_LICENSE_PLATES]: hasLicensePlates,
      [HAS_PAYMENTS]: hasPayments,
    },
    initState
  );
  const [state, dispatch] = useReducer(reducer, initState);

  const fetchUserInfo = callback => {
    repo
      .userInfo()
      .then(value => {
        dispatch({
          type: RESPONSE_USER_INFO,
          payload: value,
        });

        dispatch({
          type: HAS_PAYMENTS,
          payload: value.currentCreditCard !== null,
        });
      })
      .then(() => {
        return repo
          .fetchLicensePlates()
          .then(value => {
            dispatch({
              type: HAS_LICENSE_PLATES,
              payload: value.metadata.userLicensePlatesCount > 0,
            });
          })
          .catch(e => {
            console.log(e);
          });
      })
      .finally(() => {
        if (callback) callback();
      });
  };

  return { state, dispatch, fetchUserInfo };
};

export const useAppContext = createUseContext(useApp);
